import { HousekeepingDetailsState } from '@hkm/components/Housekeeping/Details/domain/interfaces';
import { Store } from '@hkm/store/interfaces/store';

export const selectHousekeepingDetailsState = (state: Store): HousekeepingDetailsState => state.housekeepingDetails;



// WEBPACK FOOTER //
// ./src/components/Housekeeping/Details/domain/selectors.ts